// @ts-nocheck

import * as Types from '../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type RecentlyViewedPersonFragment = {
  personUid?: string | null;
  fullName?: string | null;
  email?: string | null;
  companyWorkerId?: { value?: string | null } | null;
  title?: { value?: string | null } | null;
  profilePhoto?: { uid: string; signedUrl?: string | null } | null;
};

export type GetViewHistoryQueryVariables = Types.Exact<{
  size?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetViewHistoryQuery = { getViewHistory: { people?: Array<RecentlyViewedPersonFragment | null> | null } };

export const RecentlyViewedPersonFragmentDoc = gql`
    fragment recentlyViewedPerson on PersonModel {
  personUid
  fullName
  companyWorkerId {
    value
  }
  email
  title {
    value
  }
  profilePhoto {
    uid
    signedUrl
  }
}
    ` as unknown as DocumentNode<RecentlyViewedPersonFragment, unknown>;
export const GetViewHistoryDocument = gql`
    query getViewHistory($size: Int) {
  getViewHistory(size: $size) {
    people {
      ...recentlyViewedPerson
    }
  }
}
    ${RecentlyViewedPersonFragmentDoc}` as unknown as DocumentNode<GetViewHistoryQuery, GetViewHistoryQueryVariables>;
